module.exports = __webpack_public_path__ + "img/diamond.2a7cabf4.svg";